/* istanbul ignore file */
export const getSearch = (): string => window.location.search || '';
